import React, { useState, useEffect, Fragment } from "react";
import moment from "moment";
import axios from "axios";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { Switch, Form, Collapse } from "antd";
import { EXPENSE_STATUS_ID, roles } from "../../../configs/constants";
import { getExpenseReportsList, getExpenseRejectTypes } from "../actions/expenseReports";
import { handleError } from "../sagas";
import ManagerAccountantActionsButtons from "./MangerAccountActionsButtons.modal";
import { expenseReportsListApiUpsellProvider, presenceTripsProvider } from "./../../../lib/api/providers";
import DisplayAttachments from "./DisplayAttachments.modal";
import { forceDownload } from "../../../utils/photo.utils";
import { MEDIA_DOWNLOAD_URL } from "../../../configs/config";
import ReinvoiceInfos from "./Form/ReinvoiceInfos.form";
import ConfirmButton from "../../../components/buttons/ConfirmButton";
import { updateExpenseApi } from "../api/api";
import TripSummary from "../presence/modals/TripSummary";
import { get } from "../utils/utils";
const baseapi = process.env.REACT_APP_API + "/api";
const { Panel } = Collapse;

const ExpenseReportModal = ({
  view = "week",
  currentClient,
  isButtonAllValidateDisplayed,
  requestToTriggered,
  rejectTypes,
  closeModal,
  fetchExpenseRejectTypes,
  expensesTab,
  userRoleId,
  userId,
  token,
  form,
  isModalVisible
}) => {
  const reinvoiceInfosInit = {
    client_id: currentClient.id
  };

  const { getFieldDecorator } = form;

  const [trips, setTrips] = useState(false);
  const [dates, setDates] = useState([]);
  const fetchDatesOfMealPackages = async (expense = { ref_ids: [] }) => {
    try {
      const result = await axios.post(
        `${baseapi}/mealpackages`,
        {
          match: { "meal_package._id": expense.ref_ids },
          project: { date: 1 }
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      setDates(result.data.map(d => d.date));
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    const expense = expensesTab[0];

    if (expense.type.account_num === "791XXXXX") {
      presenceTripsProvider
        .post("/", {
          match: {
            _id: { $in: expense.ref_ids }
          }
        })
        .then(data => setTrips(data.data))
        .catch();
    }
    if (expense.type.def === "Repas CS / CDV") fetchDatesOfMealPackages(expense);
  }, [expensesTab]);

  useEffect(() => {
    if (isEmpty(rejectTypes)) fetchExpenseRejectTypes();
  }, [rejectTypes]);

  const areButtonsDisplayed = expense => {
    const status = (expense && expense.status) || {};

    if (userRoleId <= roles.MANAGER && status.id === EXPENSE_STATUS_ID.PENDING) return true;
    else if (userRoleId <= roles.DIRECTOR && status.id === EXPENSE_STATUS_ID.PREVALIDATED) return true;
    return false;
  };

  const isItPrevalidateOrValidate = () =>
    !isEmpty(expensesTab) && expensesTab[0].status.id === EXPENSE_STATUS_ID.PENDING;

  const handleOnClickAcceptAll = async () => {
    const paramsToSend = {
      _ids: expensesTab.map(expenseItem => expenseItem._id)
    };
    const endpoint = isItPrevalidateOrValidate() ? "/prevalidate" : "/validate";

    try {
      await expenseReportsListApiUpsellProvider.post(endpoint, paramsToSend, {
        headers: {
          Authorization: token
        }
      });
      requestToTriggered();
    } catch (e) {
      handleError(e);
    }
    closeModal();
  };

  const updateReinvoiceInfos = async (expense, value) => {
    try {
      expense["reinvoice_infos"] = value ? reinvoiceInfosInit : {};
      await updateExpenseApi(expense, token);
      requestToTriggered();
    } catch (e) {
      console.log("e", e);
      handleError(e);
    }
  };

  const onChangeAdvanceFees = async (expense, value) => {
    try {
      expense.advance_fee = value;
      await updateExpenseApi(expense, token);
      requestToTriggered();
    } catch (e) {
      console.log("e", e);
      handleError(e);
    }
  };

  return (
    <div className="divide-y">
      {isEmpty(expensesTab) ? (
        <div>Aucune note de frais à afficher</div>
      ) : (
        expensesTab.map(expense => {
          const isSwitchDisabled = () =>
            expense.status.id === EXPENSE_STATUS_ID.VALIDATED || expense.status.id === EXPENSE_STATUS_ID.REJECTED;
          const type = expense.type || {};
          const attachments = expense.attachements || [];
          const reinvoice_infos = expense.reinvoice_infos || {};
          const rejectedComment = get(["rejected_infos", "comment"], expense, "non renseigné");
          const rejectedType = get(["rejected_infos", "type", "label"], expense);
          const refusedComment = get(["refused_infos", "comment"], expense, "non renseigné");
          const refusedType = get(["refused_infos", "type", "label"], expense);
          return (
            <div className="py-6">
              <div className="flex justify-between">
                <div>
                  <div className="mb-4">
                    <span className="mx-2 font-bold">{`Type de frais : `}</span>
                    <div className="mt-2 ml-2 inline-flex"> {`${type.subtype ? type.subtype : "N/C"}`} </div>
                  </div>
                  {expense.status && expense.status.id === 7 && (
                    <div className="my-4">
                      <span className="my-1 mx-2 font-bold">{`Date de remboursement : `}</span>
                      <span>
                        {moment(expense.status.updated_at).format("dddd")}{" "}
                        {moment(expense.status.updated_at).format("DD/MM/YYYY")}
                      </span>
                    </div>
                  )}
                  <div className="my-4">
                    <span className="my-1 mx-2 font-bold">{`Date de déclaration : `}</span>
                    <span>
                      {moment(expense.created_at).format("dddd")} {moment(expense.created_at).format("DD/MM/YYYY")}
                    </span>
                  </div>
                  <div className="my-4">
                    <span className="my-1 mx-2 font-bold">{`Date de facture : `}</span>
                    <span>
                      {moment(expense.date).format("dddd")} {moment(expense.date).format("DD/MM/YYYY")}{" "}
                    </span>
                  </div>

                  {userRoleId !== 3 && (
                    <div className="my-4">
                      <span className="my-1 mx-2 font-bold">{`Montant HT : `}</span>
                      <span>
                        {" "}
                        {`${
                          expense.price_ht && expense.price_ht !== null
                            ? Number.parseFloat(expense.price_ht).toFixed(2)
                            : "N/C"
                        } €`}{" "}
                      </span>
                    </div>
                  )}
                  <div className="my-4">
                    <span className="my-1 mx-2 font-bold">{`Montant TTC : `}</span>
                    <span>
                      {`${
                        expense.price && expense.price !== null ? Number.parseFloat(expense.price).toFixed(2) : "N/C"
                      } €`}{" "}
                    </span>
                  </div>
                  {(userRoleId === roles.DIRECTOR || userRoleId === roles.ADMIN) &&
                    expense.tva &&
                    expense.tva.map(tvaData => {
                      return (
                        <div className="my-4">
                          <span className="my-1 mx-2 font-bold">Montant TVA {tvaData.percentage}% :</span>
                          <span> {tvaData.amount_tva} €</span>
                        </div>
                      );
                    })}
                  {Array.isArray(expense.extra_fields) && expense.extra_fields.length > 0 && (
                    <Fragment>
                      {expense.extra_fields.map(ef => {
                        return (
                          <div className="my-4" key={ef.id}>
                            <span className="my-1 mx-2 font-bold">{`${
                              ef.id === "1" ? "Volume (en Litres)" : ef.label
                            } : `}</span>
                            <span>{`${ef.value}`}</span>
                          </div>
                        );
                      })}
                    </Fragment>
                  )}
                  {expense.warning && (
                    <div className="my-4 flex flex-col justify-center items-center">
                      <span>⚠️</span>
                      <span className="my-4 mx-2 font-bold text-red-600 text-lg">{expense.warningInfos}</span>
                      <span>⚠️</span>
                    </div>
                  )}

                  {dates.length > 0 && (
                    <div className="my-4 mx-2">
                      <div>Dates des repas correspondants à cette note de frais : </div>
                      <div>
                        {dates.map(date => (
                          <div key={date}>{moment(date).format("DD-MM-YYYY")}</div>
                        ))}
                      </div>
                    </div>
                  )}
                  {refusedType && expense.status.id === EXPENSE_STATUS_ID.REFUSED && (
                    <Fragment>
                      <div className="my-4">
                        <span className="my-1 mx-2 font-bold">
                          Motif du refus : {refusedType} ({refusedComment})
                        </span>
                      </div>
                    </Fragment>
                  )}
                  {rejectedType && expense.status.id === EXPENSE_STATUS_ID.REJECTED && (
                    <Fragment>
                      <div className="my-4">
                        <span className="my-1 mx-2 font-bold">
                          Motif du rejet : {rejectedType} ({rejectedComment})
                        </span>
                      </div>
                    </Fragment>
                  )}
                  {/*<div className="my-4">*/}
                  {/*  <span className="my-1 mx-2 font-bold">{`Evénements associés : `}</span>*/}
                  {/*</div>*/}
                  {(userRoleId === roles.DIRECTOR || userRoleId === roles.ADMIN) &&
                    expense.processed &&
                    expense.processed_by && (
                      <div className="my-4">
                        <span className="my-1 mx-2 font-bold">{`${
                          expense.status.id === EXPENSE_STATUS_ID.PREVALIDATED ||
                          expense.status.id === EXPENSE_STATUS_ID.VALIDATED ||
                          expense.status.id === EXPENSE_STATUS_ID.REFUND ||
                          expense.status.id === EXPENSE_STATUS_ID.REJECTED
                            ? "Acceptée"
                            : "Refusée"
                        } le ${moment(expense.processed_at).format("dddd DD/MM/YYYY") || "N/C"} par : `}</span>
                        <span>{`${expense.processed_by.user_fullname ||
                          "acceptation ou refus automatique pour ce type de note de frais"}`}</span>
                      </div>
                    )}
                  {(userRoleId === roles.DIRECTOR || userRoleId === roles.ADMIN) &&
                    expense.validated &&
                    expense.validated_by && (
                      <div className="my-4">
                        <span className="my-1 mx-2 font-bold">{`${
                          expense.status.id === EXPENSE_STATUS_ID.VALIDATED ||
                          expense.status.id === EXPENSE_STATUS_ID.REFUND
                            ? "Validée"
                            : "Rejetée"
                        } le ${moment(expense.validated_at).format("dddd DD/MM/YYYY") || "N/C"} par : `}</span>
                        <span>{`${expense.validated_by.user_fullname || "N/C"}`}</span>
                      </div>
                    )}
                </div>
                {view === "week" && (
                  <ManagerAccountantActionsButtons
                    userId={userId}
                    // setReinvoiceChanges={setReinvoiceChanges}
                    // reinvoiceChanges={reinvoiceChanges}
                    areButtonsDisplayed={() => areButtonsDisplayed(expense)}
                    requestToTriggered={requestToTriggered}
                    token={token}
                    rejectTypes={rejectTypes}
                    userRoleId={userRoleId}
                    expense={expense}
                    closeModal={closeModal}
                    isModalVisible={isModalVisible}
                  />
                )}
              </div>
              <div
                className={
                  "flex justify-center bg-orange-500 rounded-full text-white" + " py-3 px-4 mx-2 cursor-pointer"
                }
                onClick={() =>
                  attachments
                    .map(file => {
                      return {
                        downloadUrl: MEDIA_DOWNLOAD_URL + file,
                        name: file
                      };
                    })
                    .forEach(image => {
                      return forceDownload(image.downloadUrl, image.name);
                    })
                }
              >
                Télécharger les pièces jointes
              </div>
              <div className="flex justify-end mt-2 mx-2 align-middle py-1">
                <p className="text-l mx-2 py-1 font-bold ">À refacturer</p>
                <Switch
                  disabled={isSwitchDisabled()}
                  checked={!isEmpty(expense.reinvoice_infos)}
                  size="small"
                  onChange={e => {
                    updateReinvoiceInfos(expense, e);
                    form.setFieldsValue({
                      reinvoice_infos: !e ? null : reinvoiceInfosInit
                    });
                  }}
                />
              </div>
              {(userRoleId === roles.DIRECTOR || userRoleId === roles.ADMIN) && (
                <div className="flex justify-end mt-2 mx-2 align-middle py-1">
                  <p className="text-l mx-2 py-1 font-bold ">Avance de frais</p>
                  <Switch
                    disabled={isSwitchDisabled()}
                    checked={expense.advance_fee}
                    size="small"
                    onChange={e => onChangeAdvanceFees(expense, e)}
                  />
                </div>
              )}
              {!isEmpty(expense["reinvoice_infos"]) && (
                <div>
                  <div className="mt-6">
                    <Form layout="vertical">
                      <Form.Item label="Client à refacturer">
                        {getFieldDecorator(`reinvoice_infos`, { initialValue: reinvoice_infos })(
                          <ReinvoiceInfos reinvoiceInfosToModify={expense.reinvoice_infos} />
                        )}
                      </Form.Item>
                    </Form>
                  </div>
                  <div className="flex justify-center mt-8">
                    <ConfirmButton
                      label={"Enregistrer les infos de refacturation"}
                      large={true}
                      onClick={() => {
                        form.validateFields(async (err, fields) => {
                          if (!err) {
                            try {
                              expense.reinvoice_infos = fields.reinvoice_infos;
                              await updateExpenseApi(expense, token);
                              requestToTriggered();
                            } catch (e) {
                              handleError(e);
                            }
                            closeModal();
                          }
                        });
                      }}
                    />
                  </div>
                </div>
              )}
              {attachments.length > 0 ? (
                <DisplayAttachments attachments={attachments} />
              ) : (
                <div className="flex justify-center w-full mt-4">Aucune pièce jointe à afficher</div>
              )}
            </div>
          );
        })
      )}
      {isButtonAllValidateDisplayed && (
        <div className="my-12">
          <div
            className="flex justify-center cursor-pointer mb-2 px-6 py-3 mx-2 leading-5 rounded-full bg-green-400 text-white"
            onClick={() => handleOnClickAcceptAll()}
          >
            Tout {isItPrevalidateOrValidate() ? "Valider" : "Accepter"}
          </div>
        </div>
      )}
      {trips.length > 0 && (
        <Collapse>
          <Panel header="Trajets concernés" key="1">
            <Collapse accordion>
              {trips.map((trip, index) => {
                const start_date = new moment(trip.start_date);
                const header = start_date.format("LLLL");
                return (
                  <Panel header={header} key={index}>
                    <TripSummary data={trip}></TripSummary>
                  </Panel>
                );
              })}
            </Collapse>
          </Panel>
        </Collapse>
      )}
    </div>
  );
};
const mapStateToProps = (state, ownProps) => {
  return {
    users: state.user.users || [],
    rejectTypes: state.expenseReports.rejectTypes,
    token: state.auth.token,
    currentClient: state.currentClient
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchExpenseReportsList: params => {
      dispatch(getExpenseReportsList(params));
    },
    fetchExpenseRejectTypes: () => dispatch(getExpenseRejectTypes())
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(ExpenseReportModal));



// WEBPACK FOOTER //
// src/modules/presence/components/ExpenseReportModal.js